export default "__VITE_ASSET__W5CngKHO__"